import React from "react";
import Time from "./Time";

function Footer() {
    return (
        <footer className="flex px-4 py-4 justify-center gap-6 items-center w-full border-t border-gray-800">
            <div className="w-full lg:w-[55%] flex justify-between">
                <div className="leading-none m-0 text-gray-400">made by Amarjit Khan</div>
                <Time />
            </div>
        </footer>
    );
}

export default Footer;
